import 'svelte/internal/disclose-version';

Slot_picker[$.FILENAME] = 'src/web/concepts/slot_picker.svelte';

import * as $ from 'svelte/internal/client';
import { days, times, taken, dayLabel } from "./slots";

var root = $.add_locations(
	$.from_html(
		`
      <button type="button"> </button>
    `,
		1
	),
	Slot_picker[$.FILENAME],
	[[11, 6]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
      
      <button type="button"> </button>
    `,
		1
	),
	Slot_picker[$.FILENAME],
	[[20, 6]]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<div class="flex flex-col gap-3 w-full">
  <div class="flex gap-2 overflow-x-auto">
    <!>
  </div>
  <div class="grid grid-cols-4 md:grid-cols-7 gap-2">
    <!>
  </div>
</div>`,
		1
	),
	Slot_picker[$.FILENAME],
	[[8, 0, [[9, 2], [17, 2]]]]
);

function Slot_picker($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Slot_picker);

	let value = $.prop($$props, 'value', 15, null);
	let day = $.tag($.state(0), 'day');
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_2();
	var div = $.sibling($.first_child(fragment));
	var div_1 = $.sibling($.child(div));
	var node = $.sibling($.child(div_1));

	$.add_svelte_meta(
		() => $.each(node, 17, () => days, $.index, ($$anchor, d, i) => {
			$.next();

			var fragment_1 = root();
			var button = $.sibling($.first_child(fragment_1));
			var text = $.only_child(button, true);

			$.next();

			$.template_effect(
				($0) => {
					$.set_class(button, 1, $.clsx([
						"shrink-0 px-3 py-2 border-2 border-ink font-semibold transition-colors",
						$.strict_equals($.get(day), i) ? "bg-ink text-accent" : "hover:bg-ink/10"
					]));

					$.set_text(text, $0);
				},
				[() => dayLabel($.get(d))]
			);

			$.delegated('click', button, function click() {
				return $.set(day, i, true);
			});

			$.append($$anchor, fragment_1);
		}),
		'each',
		Slot_picker,
		10,
		4
	);

	$.next();
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_1 = $.sibling($.child(div_2));

	$.add_svelte_meta(
		() => $.each(node_1, 17, () => times, $.index, ($$anchor, t, ti) => {
			const slot = $.tag($.derived(() => `${dayLabel(days[$.get(day)])} at ${$.get(t)}`), 'slot');

			$.get(slot);
			$.next();

			var fragment_2 = root_1();
			var button_1 = $.sibling($.first_child(fragment_2));
			var text_1 = $.only_child(button_1, true);

			$.next();

			$.template_effect(
				($0) => {
					button_1.disabled = $0;

					$.set_class(button_1, 1, $.clsx([
						"py-2 border-2 border-ink font-semibold tabular-nums transition-colors disabled:opacity-25 disabled:line-through",
						$.strict_equals(value(), $.get(slot)) ? "bg-ink text-accent" : "enabled:hover:bg-ink/10"
					]));

					$.set_text(text_1, $.get(t));
				},
				[() => taken($.get(day), ti)]
			);

			$.delegated('click', button_1, function click_1() {
				return value($.get(slot));
			});

			$.append($$anchor, fragment_2);
		}),
		'each',
		Slot_picker,
		18,
		4
	);

	$.next();
	$.reset(div_2);
	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Slot_picker = $.hmr(Slot_picker);

	import.meta.hot.accept((module) => {
		Slot_picker[$.HMR].update(module.default);
	});
}

export default Slot_picker;

$.delegate(['click']);